import ChannelSingleton from "../../components/Epg/ChannelsSingleton";

class FilterController {
  constructor(channelList) {
    return (async () => {
      this.channelList = channelList;
      this.setYellow = this.setYellow.bind(this);
      const filters = await new ChannelSingleton().getFilters();
      this.dataFilters = filters;
      this.yellowButton;
      return this;
    })();
  }

  setYellow(callback) {
    this.yellowButton = callback;
  }

  activate(loadObject, init = false) {
    if (loadObject && (typeof loadObject === 'object') && loadObject.filter_id) {
      const filterObject = this.dataFilters.find(el => loadObject.filter_id === el.id);
      this.setCurrentFilter(filterObject);
    } else {
      // cargando el filtro de todos
      const filterAll = this.dataFilters[0];
      this.setCurrentFilter(filterAll);
    }
    if (init) {
      this.channelList.setArrayInitFromGroupID(loadObject);
    } else {
      this.channelList.setArrayInitFromGroupIdTimeOut(loadObject);
    }

  }

  setCurrentFilter(filter) {
    this.channelList.setCurrentFilter(filter);
  }

  /**
   * @param {*} keyName Nombre de la tecla presionada
   * @param {*} event Evento de la tecla presionada
   * @param {*} repeats true si esta en modo desesperado
   * @returns
   * @memberof ChannelController
   */
  keyHandler(keyName, event, repeats) {
    let resp = true;
    if (keyName == 'YELLOW') {
      this.yellowButton();
    } else {
      resp = false;
    }
    return resp;
  }

}


export default FilterController;



// WEBPACK FOOTER //
// ./src/AAF/Nepg/FilterController.js